module.exports = __webpack_public_path__ + "img/mindful_days_90.791629e3.svg";